Buyapowa.Controllers.Share = class Share {
  constructor(el) {
    this.el = el;
    this.view = new Buyapowa.Views.Share(this.el);
  }
};
